import React, { useEffect, useState } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatFecha, getTableBd } from '../../config/functions';

// Función para determinar la cuadrilla según jornada
const getCuadrilla = (emp, tipoJornada) => {
    if (emp.cargo === 'OBRERO DE PATIO') return 'OBREROS DE PATIO';
    if ((emp.horario === '00:00-00:00' && emp.horas === 24) || emp.cargo === 'SUPERVISOR') return '24 HORAS';
    if (emp.horario === '00:00-00:00' && emp.horas === 0) return 'CUADRILLA DESCANSO';
    if (tipoJornada === '12h') {
        if (emp.horario === '06:00-18:00') return 'CUADRILLA 06:00-18:00';
        if (emp.horario === '18:00-06:00') return 'CUADRILLA 18:00-06:00';
    } else {
        if (emp.horario === '06:00-14:00') return 'CUADRILLA 06:00-14:00';
        if (emp.horario === '14:00-22:00') return 'CUADRILLA 14:00-22:00';
        if (emp.horario === '22:00-06:00') return 'CUADRILLA 22:00-06:00';
    }
    return 'OTROS';
};

const ExportToExcelButton = ({
    reporteActividades = [],
    dataEmpleadosHoy = [],
    mobile,
    fecha,
    encabezado = {},
    operadoras = [],
    camposPozos = [],
    rigs = [],
    tipoJornada = '8h',
}) => {

    const [campo, setCampo] = useState('');
    const [pozo, setPozo] = useState('');
    const [operadora, setOperadora] = useState('');
    const [rig, setRig] = useState('');

    const fillStyle = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFCCCCCC' }, // Color de fondo gris claro
    }

    const border2Style = {
        style: 'medium',
        color: { argb: 'FF000000' }
    }

    useEffect(() => {
        if (encabezado.campo) {
            const campoData = camposPozos.find(c => c.id === parseInt(encabezado.campo));
            setCampo(campoData?.campo || '');
        }
        if (encabezado.pozo) {
            const pozoData = camposPozos.find(p => p.id === parseInt(encabezado.pozo));
            setPozo(pozoData?.pozo || '');
        }
        if (encabezado.operadora) {
            const operadoraData = operadoras.find(o => o.id === parseInt(encabezado.operadora));
            setOperadora(operadoraData?.name || '');
        }
        if (encabezado.rig) {
            const rigData = rigs.find(r => parseInt(r.nb_tldro_idn) === encabezado.rig);
            setRig(rigData?.vr_tldro_nom || '');
        }
    }, [encabezado]);


    const exportToExcel = async () => {

        const fechaddMMYYYY = fecha ? new Date(fecha).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        }) : '';
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(`DOR ${fechaddMMYYYY}`);



        // --- Título ---------------------------------------------------------------------------------
        sheet.mergeCells('A1:I1');
        sheet.getCell('A1').value = 'REPORTE DIARIO OPERACIONAL';
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').font = { bold: true, size: 16 };



        // --- Encabezado superior --------------------------------------------------------------------
        // Etiquetas
        sheet.getCell('A2').value = 'Operador:';
        sheet.getCell('D2').value = 'Rig:';
        sheet.getCell('G2').value = 'Campo:';
        sheet.getCell('A3').value = 'Pozo:';
        sheet.getCell('D3').value = 'Fecha:';
        sheet.getCell('G3').value = 'Verificado:';

        // Combina celdas para valores largos
        sheet.mergeCells('B2:C2');
        sheet.mergeCells('B3:C3');
        sheet.mergeCells('E2:F2');
        sheet.mergeCells('E3:F3');
        sheet.mergeCells('H2:I2');
        sheet.mergeCells('H3:I3');

        // Valores
        sheet.getCell('B2').value = operadora || '';
        sheet.getCell('B3').value = pozo || '';
        sheet.getCell('E2').value = rig || '';
        sheet.getCell('E3').value = fecha || encabezado.fecha || '';
        sheet.getCell('H2').value = campo || '';
        sheet.getCell('H3').value = encabezado.usuario_verifica
            ? encabezado.usuario_verifica + ' ' + formatFecha(encabezado.fecha_verifica) : '';

        // Opcional: negrita y fondo para etiquetas
        ['A2', 'D2', 'G2', 'A3', 'D3', 'G3'].forEach(cell => {
            sheet.getCell(cell).font = { bold: true };
            sheet.getCell(cell).fill = fillStyle;
        });

        // --- Bordes internos thin y exterior medium encabezado (f 2 y 3, col A-I) 
        for (let row = 2; row <= 3; row++) {
            for (let col = 1; col <= 9; col++) { // A=1 ... I=9
                const cell = sheet.getCell(getExcelAlpha(col) + row);
                cell.border = {
                    top: row === 2 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: row === 3 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    left: col === 1 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    right: col === 9 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                };
            }
        }

        // --- Espacio ---
        sheet.addRow([]);




        // --- Tabla de actividades (tiempos) --------------------------------------------------------
        const headerRowNum = sheet.lastRow.number + 1;
        sheet.getCell(`A${headerRowNum}`).value = 'Desde';
        sheet.getCell(`B${headerRowNum}`).value = 'Hasta';
        sheet.getCell(`C${headerRowNum}`).value = 'Total';
        sheet.getCell(`D${headerRowNum}`).value = 'Operación';
        // Combina E y F para Actividad
        sheet.mergeCells(`E${headerRowNum}:F${headerRowNum}`);
        sheet.getCell(`E${headerRowNum}`).value = 'Actividad';
        // Combina G, H e I para Observación
        sheet.mergeCells(`G${headerRowNum}:I${headerRowNum}`);
        sheet.getCell(`G${headerRowNum}`).value = 'Observación';

        // Estilos para el header
        for (let col = 1; col <= 9; col++) {
            const cell = sheet.getCell(getExcelAlpha(col) + headerRowNum);
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
        }

        // Guarda la fila de inicio de la tabla
        const actividadStartRow = headerRowNum;

        // Agrega las filas de datos y combina celdas para actividad y observación
        // Calcula el total de horas
        const totalHoras = reporteActividades.reduce((acc, act) => acc + (parseFloat(act.total) || 0), 0);

        reporteActividades.forEach((act, idx) => {
            const rowNum = sheet.lastRow.number + 1;
            sheet.getCell(`A${rowNum}`).value = act.desde;
            sheet.getCell(`B${rowNum}`).value = act.hasta;
            sheet.getCell(`C${rowNum}`).value = act.total;
            sheet.getCell(`D${rowNum}`).value = act.operacion;
            sheet.mergeCells(`E${rowNum}:F${rowNum}`);// Actividad (E y F combinadas)
            sheet.getCell(`E${rowNum}`).value = act.actividad;
            sheet.mergeCells(`G${rowNum}:I${rowNum}`);// Observación (G, H, I combinadas)
            sheet.getCell(`G${rowNum}`).value = act.observacion || '';
        });

        // --- Total horas ---
        const totalRowNum = sheet.lastRow.number + 1;
        sheet.mergeCells(`A${totalRowNum}:B${totalRowNum}`);
        sheet.getCell(`A${totalRowNum}`).value = 'TOTAL HORAS';
        sheet.getCell(`C${totalRowNum}`).value = totalHoras;
        sheet.mergeCells(`D${totalRowNum}:I${totalRowNum}`);
        sheet.getCell(`A${totalRowNum}`).alignment = { horizontal: 'right' };
        sheet.getCell(`A${totalRowNum}`).font = { bold: true };
        sheet.getCell(`C${totalRowNum}`).font = { bold: true };
        // Fondo gris para la fila de total de horas
        for (let col = 1; col <= 9; col++) {
            sheet.getCell(getExcelAlpha(col) + totalRowNum).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
        }

        // --- Bordes internos thin y exterior medium para la tabla de actividades (A-I) ---
        const actividadEndRow = totalRowNum;
        const actividadStartCol = 1; // Columna A
        const actividadEndCol = 9;   // Columna I

        for (let row = actividadStartRow; row <= actividadEndRow; row++) {
            for (let col = actividadStartCol; col <= actividadEndCol; col++) {
                const cell = sheet.getCell(getExcelAlpha(col) + row);
                cell.border = {
                    top: row === actividadStartRow ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: row === actividadEndRow ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    left: col === actividadStartCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    right: col === actividadEndCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                };
            }
        }

        // Función auxiliar para convertir número de columna a letra
        function getExcelAlpha(n) {
            let s = '';
            while (n > 0) {
                let m = (n - 1) % 26;
                s = String.fromCharCode(65 + m) + s;
                n = Math.floor((n - m) / 26);
            }
            return s;
        }
        // --- Espacio ---
        sheet.addRow([]);




        // --- Procesar empleados y cuadrillas -----------------------------------------------------
        const empleadosCuadrilla = dataEmpleadosHoy.map(emp => ({
            ...emp,
            cuadrilla: getCuadrilla(emp, tipoJornada)
        }));




        // Cuadrillas principales (dinámico según jornada) ---------------------------------------------------------
        const cuadrillasPrincipales = tipoJornada === '12h'
            ? ['CUADRILLA 06:00-18:00', 'CUADRILLA 18:00-06:00']
            : ['CUADRILLA 06:00-14:00', 'CUADRILLA 14:00-22:00', 'CUADRILLA 22:00-06:00'];

        const numCuadrillasPrincipales = cuadrillasPrincipales.length;
        const colsPerCuadPrincipal = tipoJornada === '12h' ? 4 : 3; // 12h: 2 cuadrillas de 4 cols + 1 vacía = 9 cols
        const cuadrillasEmpleados = cuadrillasPrincipales.map(nombre => ({
            nombre,
            empleados: empleadosCuadrilla.filter(e => e.cuadrilla === nombre)
        }));

        // --- Encabezado de cuadrillas principales con merge ---
        let colIndex = 1;
        const cuadrillaTitleRow = sheet.lastRow.number + 1;

        cuadrillasEmpleados.forEach((cuad, idx) => {
            const startCol = colIndex;
            const endCol = colIndex + colsPerCuadPrincipal - 1;
            const cellRange = `${getExcelAlpha(startCol)}${cuadrillaTitleRow}:${getExcelAlpha(endCol)}${cuadrillaTitleRow}`;
            sheet.mergeCells(cellRange);
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow}`).value = `${cuad.nombre} (${cuad.empleados.length})`;
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow}`).alignment = { horizontal: 'center' };
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow}`).font = { bold: true };
            colIndex += colsPerCuadPrincipal;
        });
        // Si 12h (2 cuadrillas × 4 = 8 cols), rellenamos col 9
        if (tipoJornada === '12h') {
            sheet.getCell(`${getExcelAlpha(9)}${cuadrillaTitleRow}`).value = '';
        }

        // Fila de encabezados
        let subHeader = [];
        cuadrillasEmpleados.forEach(() => {
            subHeader.push('Cargo', 'Nombre', 'Horas');
            if (tipoJornada === '12h') subHeader.push(''); // col extra para 12h
        });
        const cuadrillaHeaderRow = sheet.addRow(subHeader);

        // Fondo gris y negrita para encabezados
        const totalColsPrinc = numCuadrillasPrincipales * colsPerCuadPrincipal;
        for (let col = 1; col <= totalColsPrinc; col++) {
            const cellTitle = sheet.getCell(getExcelAlpha(col) + cuadrillaTitleRow);
            cellTitle.font = { bold: true };
            cellTitle.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
            const cellHeader = sheet.getCell(getExcelAlpha(col) + cuadrillaHeaderRow.number);
            cellHeader.font = { bold: true };
            cellHeader.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
        }

        // Máximo de empleados en una cuadrilla principal
        const maxEmpleados = Math.max(...cuadrillasEmpleados.map(c => c.empleados.length), 0);
        for (let i = 0; i < maxEmpleados; i++) {
            let row = [];
            cuadrillasEmpleados.forEach(cuad => {
                const emp = cuad.empleados[i];
                if (emp) {
                    row.push(emp.cargo, emp.empleado, emp.horas);
                } else {
                    row.push('', '', '');
                }
                if (tipoJornada === '12h') row.push(''); // col extra
            });
            if (row.length > 0) sheet.addRow(row);
        }

        // Aplica estilos a cargos y horas en cuadrillas principales
        const cargoColsPrinc = [];
        const horasColsPrinc = [];
        for (let c = 0; c < numCuadrillasPrincipales; c++) {
            cargoColsPrinc.push(c * colsPerCuadPrincipal + 1);
            horasColsPrinc.push(c * colsPerCuadPrincipal + 3);
        }
        for (let i = 0; i < maxEmpleados; i++) {
            const rowNum = cuadrillaHeaderRow.number + 1 + i;
            cargoColsPrinc.forEach(col => {
                sheet.getCell(getExcelAlpha(col) + rowNum).font = { bold: true };
            });
            horasColsPrinc.forEach(col => {
                sheet.getCell(getExcelAlpha(col) + rowNum).alignment = { horizontal: 'center' };
            });
        }

        sheet.addRow([]);

        // --- Bordes por cuadrilla principal ---
        const cuadrillaBloques = [];
        for (let c = 0; c < numCuadrillasPrincipales; c++) {
            cuadrillaBloques.push({
                startCol: c * colsPerCuadPrincipal + 1,
                endCol: (c + 1) * colsPerCuadPrincipal
            });
        }
        const cuadrillaStartRow = cuadrillaTitleRow;
        const cuadrillaEndRow = cuadrillaTitleRow + 1 + maxEmpleados; // +1 encabezado, +maxEmpleados filas

        cuadrillaBloques.forEach(({ startCol, endCol }) => {
            for (let row = cuadrillaStartRow; row <= cuadrillaEndRow; row++) {
                for (let col = startCol; col <= endCol; col++) {
                    const cell = sheet.getCell(getExcelAlpha(col) + row);
                    cell.border = {
                        top: row === cuadrillaStartRow ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        bottom: row === cuadrillaEndRow ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        left: col === startCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        right: col === endCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    };
                }
            }
        });



        // Cuadrillas Descanso, Obreros de Patio y 24 horas ---------------------------------------------------------
        // Define las cuadrillas secundarias (1, 2 y 3)
        const cuadrillasSecundarias = ['CUADRILLA DESCANSO', 'OBREROS DE PATIO', '24 HORAS'];
        const cuadrillasEmpleados2 = cuadrillasSecundarias.map(nombre => ({
            nombre,
            empleados: empleadosCuadrilla.filter(e => e.cuadrilla === nombre)
        }));

        // --- Encabezado de cuadrillas secundarias con merge ---
        let colIndex2 = 1;
        const cuadrillaTitleRow2 = sheet.lastRow.number + 1;

        cuadrillasEmpleados2.forEach((cuad, idx) => {
            const startCol = colIndex2;
            const endCol = colIndex2 + 2;
            const cellRange = `${getExcelAlpha(startCol)}${cuadrillaTitleRow2}:${getExcelAlpha(endCol)}${cuadrillaTitleRow2}`;
            sheet.mergeCells(cellRange);
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow2}`).value =
                `${cuad.nombre === '24 HORAS' ? 'STAFF' : cuad.nombre} (${cuad.empleados.length})`;
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow2}`).alignment = { horizontal: 'center' };
            sheet.getCell(`${getExcelAlpha(startCol)}${cuadrillaTitleRow2}`).font = { bold: true };
            colIndex2 += 3;
        });

        // Fila de encabezados
        let subHeader2 = [];
        cuadrillasEmpleados2.forEach(cuad => {
            if (cuad.nombre === 'CUADRILLA DESCANSO' || cuad.nombre === '24 HORAS') {
                subHeader2.push('Cargo', 'Nombre', ''); // Se combinarán las celdas de Nombre y Horas
            } else {
                subHeader2.push('Cargo', 'Nombre', 'Horas');
            }
        });
        const cuadrillaHeaderRow2 = sheet.addRow(subHeader2);

        // Combina celdas de encabezado para CUADRILLA DESCANSO y 24 HORAS (Nombre y Horas)
        let colHeader = 1;
        cuadrillasEmpleados2.forEach(cuad => {
            if (cuad.nombre === 'CUADRILLA DESCANSO' || cuad.nombre === '24 HORAS') {
                // Combina columnas "Nombre" y "Horas" (colHeader+1 y colHeader+2)
                sheet.mergeCells(
                    `${getExcelAlpha(colHeader + 1)}${cuadrillaHeaderRow2.number}:${getExcelAlpha(colHeader + 2)}${cuadrillaHeaderRow2.number}`
                );
            }
            colHeader += 3;
        });

        // Fondo gris y negrita para encabezados
        for (let col = 1; col <= cuadrillasEmpleados2.length * 3; col++) {
            const cellTitle = sheet.getCell(getExcelAlpha(col) + cuadrillaTitleRow2);
            cellTitle.font = { bold: true };
            cellTitle.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
            const cellHeader = sheet.getCell(getExcelAlpha(col) + cuadrillaHeaderRow2.number);
            cellHeader.font = { bold: true };
            cellHeader.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' }
            };
        }

        // Máximo de empleados en una cuadrilla secundaria
        const maxEmpleados2 = Math.max(...cuadrillasEmpleados2.map(c => c.empleados.length));
        for (let i = 0; i < maxEmpleados2; i++) {
            let row = [];
            let mergeInstructions = [];
            cuadrillasEmpleados2.forEach((cuad, idx) => {
                const emp = cuad.empleados[i];
                const baseCol = idx * 3;
                if (cuad.nombre === 'CUADRILLA DESCANSO' || cuad.nombre === '24 HORAS') {
                    row[baseCol] = emp ? (emp.cargo === 'SUPERVISOR' ? 'SUP. ' + emp.horario : emp.cargo) : '';
                    row[baseCol + 1] = emp ? emp.empleado : '';
                    row[baseCol + 2] = ''; // Horas vacío
                    // Guardar instrucción para combinar celdas de Nombre y Horas
                    const rowNum = sheet.lastRow ? sheet.lastRow.number + 1 : cuadrillaHeaderRow2.number + 1 + i;
                    mergeInstructions.push({
                        from: getExcelAlpha(baseCol + 2) + rowNum,
                        to: getExcelAlpha(baseCol + 3) + rowNum
                    });
                } else {
                    row[baseCol] = emp ? emp.cargo : '';
                    row[baseCol + 1] = emp ? emp.empleado : '';
                    row[baseCol + 2] = emp ? emp.horas : '';
                }
            });
            // Agrega la fila solo si hay algún dato
            if (row.length > 0 && row.some(cell => cell !== undefined)) {
                sheet.addRow(row);
                // Realiza los merges para las cuadrillas de descanso y 24 horas
                mergeInstructions.forEach(({ from, to }) => {
                    sheet.mergeCells(`${from}:${to}`);
                });
            }
        }

        // Aplica estilos a cargos y horas en cuadrillas secundarias
        for (let i = 0; i < maxEmpleados2; i++) {
            const rowNum = cuadrillaHeaderRow2.number + 1 + i;
            [1, 4, 7].forEach(col => { // Cargos en negrita
                sheet.getCell(getExcelAlpha(col) + rowNum).font = { bold: true };
            });
            [6].forEach(col => { // Horas centradas
                sheet.getCell(getExcelAlpha(col) + rowNum).alignment = { horizontal: 'center' };
            });
        }

        sheet.addRow([]);

        // --- Bordes por cuadrilla secundaria ---
        const cuadrillaBloques2 = [
            { startCol: 1, endCol: 3 },   // DESCANSO: A-C
            { startCol: 4, endCol: 6 },   // OBREROS DE PATIO: D-F
            { startCol: 7, endCol: 9 },   // 24 HORAS: G-I
        ];
        const cuadrillaStartRow2 = cuadrillaTitleRow2;
        const cuadrillaEndRow2 = cuadrillaTitleRow2 + 1 + maxEmpleados2; // +1 encabezado, +maxEmpleados2 filas

        cuadrillaBloques2.forEach(({ startCol, endCol }) => {
            for (let row = cuadrillaStartRow2; row <= cuadrillaEndRow2; row++) {
                for (let col = startCol; col <= endCol; col++) {
                    const cell = sheet.getCell(getExcelAlpha(col) + row);
                    cell.border = {
                        top: row === cuadrillaStartRow2 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        bottom: row === cuadrillaEndRow2 ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        left: col === startCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                        right: col === endCol ? { style: 'medium', color: { argb: 'FF000000' } } : { style: 'thin', color: { argb: 'FF000000' } },
                    };
                }
            }
        });


        // Ajusta el ancho de columnas de forma específica--------------------------------------------------------
        sheet.columns = [
            { width: 20 }, // A
            { width: 25 }, // B (más grande)
            { width: 9 },  // C (más pequeño)
            { width: 20 }, // D
            { width: 25 }, // E (más grande)
            { width: 9 },  // F (más pequeño)
            { width: 20 }, // G
            { width: 25 }, // H (más grande)
            { width: 9 },  // I (más pequeño)
        ];


        // --- SECCIÓN TONELADAS MILLA -------------------------------------------------------------------
        if (encabezado.id) {
            try {
                const dataTM = await getTableBd('getToneladasMillaRDE/' + encabezado.id);
                {
                    const tm = dataTM.length > 0 ? dataTM[0] : {};
                    sheet.addRow([]);

                    const tmTitleRow = sheet.lastRow.number + 1;
                    sheet.mergeCells(`A${tmTitleRow}:I${tmTitleRow}`);
                    sheet.getCell(`A${tmTitleRow}`).value = 'TONELADAS MILLA';
                    sheet.getCell(`A${tmTitleRow}`).alignment = { vertical: 'middle', horizontal: 'center' };
                    sheet.getCell(`A${tmTitleRow}`).font = { bold: true, size: 13 };
                    sheet.getCell(`A${tmTitleRow}`).fill = fillStyle;
                    for (let col = 1; col <= 9; col++) {
                        sheet.getCell(getExcelAlpha(col) + tmTitleRow).border = {
                            top: border2Style, bottom: border2Style,
                            left: col === 1 ? border2Style : { style: 'thin' },
                            right: col === 9 ? border2Style : { style: 'thin' },
                        };
                    }

                    const tmFields = [
                        ['Fecha Últ. Corrida', tm.fecha_ultima_corrida ? new Date(tm.fecha_ultima_corrida).toLocaleDateString('es-ES') : '', 'Fecha Últ. Cortada', tm.fecha_ultima_cortada ? new Date(tm.fecha_ultima_cortada).toLocaleDateString('es-ES') : ''],
                        ['Longitud Corrida (FT)', tm.longitud_corrida || 0, 'Longitud Cortada (FT)', tm.longitud_cortada || 0],
                        ['Anterior', tm.anterior || 0, 'Hoy', tm.hoy || 0],
                        ['Total', tm.total || 0, 'Cable Remanente (FT)', tm.cable_remanente || 0],
                    ];

                    const tmStartRow = sheet.lastRow.number + 1;
                    tmFields.forEach(fields => {
                        const rowNum = sheet.lastRow.number + 1;
                        sheet.mergeCells(`A${rowNum}:B${rowNum}`);
                        sheet.getCell(`A${rowNum}`).value = fields[0];
                        sheet.getCell(`A${rowNum}`).font = { bold: true };
                        sheet.getCell(`A${rowNum}`).fill = fillStyle;
                        sheet.mergeCells(`C${rowNum}:D${rowNum}`);
                        sheet.getCell(`C${rowNum}`).value = fields[1];

                        sheet.mergeCells(`F${rowNum}:G${rowNum}`);
                        sheet.getCell(`F${rowNum}`).value = fields[2];
                        sheet.getCell(`F${rowNum}`).font = { bold: true };
                        sheet.getCell(`F${rowNum}`).fill = fillStyle;
                        sheet.mergeCells(`H${rowNum}:I${rowNum}`);
                        sheet.getCell(`H${rowNum}`).value = fields[3];

                        // Columna E vacía como separador
                        sheet.getCell(`E${rowNum}`).value = '';
                    });
                    const tmEndRow = sheet.lastRow.number;

                    // Bordes para Toneladas Milla
                    for (let row = tmStartRow; row <= tmEndRow; row++) {
                        for (let col = 1; col <= 9; col++) {
                            const cell = sheet.getCell(getExcelAlpha(col) + row);
                            cell.border = {
                                top: row === tmStartRow ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                bottom: row === tmEndRow ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                left: (col === 1 || col === 6) ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                right: (col === 4 || col === 9) ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                            };
                        }
                    }

                    // Verificación TM
                    if (tm.usuario_verifica) {
                        const vRowNum = sheet.lastRow.number + 1;
                        sheet.mergeCells(`A${vRowNum}:I${vRowNum}`);
                        sheet.getCell(`A${vRowNum}`).value = `Verificado por: ${tm.usuario_verifica} - ${tm.fecha_verifica ? formatFecha(tm.fecha_verifica) : ''}`;
                        sheet.getCell(`A${vRowNum}`).font = { bold: true, color: { argb: 'FF008000' } };
                        sheet.getCell(`A${vRowNum}`).alignment = { horizontal: 'center' };
                    }
                }
            } catch (e) { console.error('Error exportando Toneladas Milla:', e); }
        }


        // --- SECCIÓN COMBUSTIBLE (A.C.P.M.) -----------------------------------------------------------
        if (encabezado.id) {
            try {
                const dataComb = await getTableBd('getCombustibleRDE/' + encabezado.id);
                {
                    const cb = dataComb.length > 0 ? dataComb[0] : {};
                    sheet.addRow([]);

                    const cbTitleRow = sheet.lastRow.number + 1;
                    sheet.mergeCells(`A${cbTitleRow}:I${cbTitleRow}`);
                    sheet.getCell(`A${cbTitleRow}`).value = 'COMBUSTIBLE (A.C.P.M.)';
                    sheet.getCell(`A${cbTitleRow}`).alignment = { vertical: 'middle', horizontal: 'center' };
                    sheet.getCell(`A${cbTitleRow}`).font = { bold: true, size: 13 };
                    sheet.getCell(`A${cbTitleRow}`).fill = fillStyle;
                    for (let col = 1; col <= 9; col++) {
                        sheet.getCell(getExcelAlpha(col) + cbTitleRow).border = {
                            top: border2Style, bottom: border2Style,
                            left: col === 1 ? border2Style : { style: 'thin' },
                            right: col === 9 ? border2Style : { style: 'thin' },
                        };
                    }

                    // Encabezado: Stock, Ayer, Recibido
                    const cbHeaderRow = sheet.lastRow.number + 1;
                    const cbHeaderLabels = ['Stock', '', '', 'Ayer', '', '', 'Recibido', '', ''];
                    const cbHeaderValues = [cb.stock || 0, '', '', cb.ayer || 0, '', '', cb.recibido || 0, '', ''];

                    // Fila etiquetas
                    sheet.mergeCells(`A${cbHeaderRow}:C${cbHeaderRow}`);
                    sheet.getCell(`A${cbHeaderRow}`).value = 'Stock';
                    sheet.getCell(`A${cbHeaderRow}`).font = { bold: true };
                    sheet.getCell(`A${cbHeaderRow}`).fill = fillStyle;
                    sheet.getCell(`A${cbHeaderRow}`).alignment = { horizontal: 'center' };
                    sheet.mergeCells(`D${cbHeaderRow}:F${cbHeaderRow}`);
                    sheet.getCell(`D${cbHeaderRow}`).value = 'Ayer';
                    sheet.getCell(`D${cbHeaderRow}`).font = { bold: true };
                    sheet.getCell(`D${cbHeaderRow}`).fill = fillStyle;
                    sheet.getCell(`D${cbHeaderRow}`).alignment = { horizontal: 'center' };
                    sheet.mergeCells(`G${cbHeaderRow}:I${cbHeaderRow}`);
                    sheet.getCell(`G${cbHeaderRow}`).value = 'Recibido';
                    sheet.getCell(`G${cbHeaderRow}`).font = { bold: true };
                    sheet.getCell(`G${cbHeaderRow}`).fill = fillStyle;
                    sheet.getCell(`G${cbHeaderRow}`).alignment = { horizontal: 'center' };

                    // Fila valores
                    const cbValRow = sheet.lastRow.number + 1;
                    sheet.mergeCells(`A${cbValRow}:C${cbValRow}`);
                    sheet.getCell(`A${cbValRow}`).value = cb.stock || 0;
                    sheet.getCell(`A${cbValRow}`).alignment = { horizontal: 'center' };
                    sheet.mergeCells(`D${cbValRow}:F${cbValRow}`);
                    sheet.getCell(`D${cbValRow}`).value = cb.ayer || 0;
                    sheet.getCell(`D${cbValRow}`).alignment = { horizontal: 'center' };
                    sheet.mergeCells(`G${cbValRow}:I${cbValRow}`);
                    sheet.getCell(`G${cbValRow}`).value = cb.recibido || 0;
                    sheet.getCell(`G${cbValRow}`).alignment = { horizontal: 'center' };

                    // Consumos por equipo - tabla de 2 columnas
                    const cbConsumoTitleRow = sheet.lastRow.number + 1;
                    sheet.mergeCells(`A${cbConsumoTitleRow}:I${cbConsumoTitleRow}`);
                    sheet.getCell(`A${cbConsumoTitleRow}`).value = 'Consumos por Equipo';
                    sheet.getCell(`A${cbConsumoTitleRow}`).font = { bold: true };
                    sheet.getCell(`A${cbConsumoTitleRow}`).fill = fillStyle;
                    sheet.getCell(`A${cbConsumoTitleRow}`).alignment = { horizontal: 'center' };

                    const consumoItems = [
                        { label: 'Generador 1', value: cb.generador_1 || 0 },
                        { label: 'Generador 2', value: cb.generador_2 || 0 },
                        { label: 'Unidad Básica', value: cb.unidad_basica || 0 },
                        { label: 'Bomba de Lodos', value: cb.bomba_lodos || 0 },
                        { label: 'Grúa', value: cb.grua || 0 },
                        { label: 'Cargador', value: cb.cargador || 0 },
                        { label: 'Pipe Handler', value: cb.pipe_handler || 0 },
                        { label: 'Planta Estadio', value: cb.planta_estadio || 0 },
                        { label: 'Limpieza de Tubería', value: cb.limpieza_tuberia || 0 },
                        { label: 'Camioneta', value: cb.camioneta || 0 },
                        { label: 'Tractocamión', value: cb.tractocamion || 0 },
                        { label: 'Otros', value: cb.otros || 0 },
                    ];

                    // Consumos en 3 columnas (etiqueta-valor pares)
                    for (let i = 0; i < consumoItems.length; i += 3) {
                        const rowNum = sheet.lastRow.number + 1;
                        // Col 1: A-B label, C value
                        sheet.mergeCells(`A${rowNum}:B${rowNum}`);
                        sheet.getCell(`A${rowNum}`).value = consumoItems[i].label;
                        sheet.getCell(`A${rowNum}`).font = { bold: true };
                        sheet.getCell(`C${rowNum}`).value = consumoItems[i].value;
                        sheet.getCell(`C${rowNum}`).alignment = { horizontal: 'center' };

                        // Col 2: D-E label, F value
                        if (i + 1 < consumoItems.length) {
                            sheet.mergeCells(`D${rowNum}:E${rowNum}`);
                            sheet.getCell(`D${rowNum}`).value = consumoItems[i + 1].label;
                            sheet.getCell(`D${rowNum}`).font = { bold: true };
                            sheet.getCell(`F${rowNum}`).value = consumoItems[i + 1].value;
                            sheet.getCell(`F${rowNum}`).alignment = { horizontal: 'center' };
                        }

                        // Col 3: G-H label, I value
                        if (i + 2 < consumoItems.length) {
                            sheet.mergeCells(`G${rowNum}:H${rowNum}`);
                            sheet.getCell(`G${rowNum}`).value = consumoItems[i + 2].label;
                            sheet.getCell(`G${rowNum}`).font = { bold: true };
                            sheet.getCell(`I${rowNum}`).value = consumoItems[i + 2].value;
                            sheet.getCell(`I${rowNum}`).alignment = { horizontal: 'center' };
                        }
                    }

                    // Totales
                    const cbTotalRow = sheet.lastRow.number + 1;
                    sheet.mergeCells(`A${cbTotalRow}:C${cbTotalRow}`);
                    sheet.getCell(`A${cbTotalRow}`).value = 'Total Consumo';
                    sheet.getCell(`A${cbTotalRow}`).font = { bold: true };
                    sheet.getCell(`A${cbTotalRow}`).alignment = { horizontal: 'center' };
                    sheet.getCell(`A${cbTotalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
                    sheet.mergeCells(`D${cbTotalRow}:F${cbTotalRow}`);
                    sheet.getCell(`D${cbTotalRow}`).value = cb.total_consumo || 0;
                    sheet.getCell(`D${cbTotalRow}`).alignment = { horizontal: 'center' };
                    sheet.getCell(`D${cbTotalRow}`).font = { bold: true };
                    sheet.getCell(`D${cbTotalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };

                    sheet.mergeCells(`G${cbTotalRow}:H${cbTotalRow}`);
                    sheet.getCell(`G${cbTotalRow}`).value = 'Existencia Hoy';
                    sheet.getCell(`G${cbTotalRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                    sheet.getCell(`G${cbTotalRow}`).alignment = { horizontal: 'center' };
                    sheet.getCell(`G${cbTotalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28A745' } };
                    sheet.getCell(`I${cbTotalRow}`).value = cb.existencia_hoy || 0;
                    sheet.getCell(`I${cbTotalRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                    sheet.getCell(`I${cbTotalRow}`).alignment = { horizontal: 'center' };
                    sheet.getCell(`I${cbTotalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28A745' } };

                    // Bordes para toda la sección combustible
                    const cbStartRow = cbHeaderRow;
                    const cbEndRow = cbTotalRow;
                    for (let row = cbStartRow; row <= cbEndRow; row++) {
                        for (let col = 1; col <= 9; col++) {
                            const cell = sheet.getCell(getExcelAlpha(col) + row);
                            cell.border = {
                                top: row === cbStartRow ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                bottom: row === cbEndRow ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                left: col === 1 ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                                right: col === 9 ? border2Style : { style: 'thin', color: { argb: 'FF000000' } },
                            };
                        }
                    }

                    // Verificación Combustible
                    if (cb.usuario_verifica) {
                        const vRowNum = sheet.lastRow.number + 1;
                        sheet.mergeCells(`A${vRowNum}:I${vRowNum}`);
                        sheet.getCell(`A${vRowNum}`).value = `Verificado por: ${cb.usuario_verifica} - ${cb.fecha_verifica ? formatFecha(cb.fecha_verifica) : ''}`;
                        sheet.getCell(`A${vRowNum}`).font = { bold: true, color: { argb: 'FF008000' } };
                        sheet.getCell(`A${vRowNum}`).alignment = { horizontal: 'center' };
                    }
                }
            } catch (e) { console.error('Error exportando Combustible:', e); }
        }


        // Exporta el archivo-------------------------------------------------------------------------------------
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Reporte_${fecha}.xlsx`);
    };

    return (
        <button
            className="btn btn-success fa-solid fa-file-excel"
            onClick={() => exportToExcel()}
            title="Exportar a Excel"
        />
    );
};

export default ExportToExcelButton;